import * as Popover from '@components/DropdownMenu'
import { FontAwesomeIcon, findIconDefinition } from '@purposity/icons'
import { analytics } from '@services/Analytics'
import * as Colors from '@themes/Colors'
import * as React from 'react'
import { useState } from 'react'
import { Share, StyleSheet, View } from 'react-native'
import { useRouter } from 'solito/router'

import { useActionParamsFromAlias, useOrg } from '../hooks/useOrganizations'
import { useOrgActions } from '../hooks/useUserOrgs'

import { useAuthContext } from '~/features/auth/components/AuthProvider'
import { QrModal } from '~/features/organizations/components/QrModal'

type Props = {
  aliasOrValias: string
  color?: string
}

export function OrgActionMenu(props: Props) {
  const {
    isFollower: isOrgSubscriber,
    follow,
    unfollow,
    donate,
    _donate,
    _follow,
    _unfollow,
  } = useOrgActions({ aliasOrValias: props.aliasOrValias })
  const query = useOrg(props.aliasOrValias)
  const { user } = useAuthContext()

  const idWithAlias = useActionParamsFromAlias(props.aliasOrValias)
  const router = useRouter()
  const { status, failureCount, enabled } = _donate

  const [isQrModalOpen, setIsQrModalOpen] = useState(false)

  const handleShare = async () => {
    const auto_join_team = query.data?.auto_join_team
    let qs = ''
    if (auto_join_team) {
      qs = `?team=${auto_join_team}`
    }
    const url = `https://purposity.com/organization/${props.aliasOrValias}${qs}`

    try {
      await Share.share({
        url,
        message: `Check out this organization on Purposity!`,
      })

      // Track organization share event
      if (query.data?.id) {
        analytics.track('Organization Share', {
          orgId: query.data.id,
          orgName: query.data.name || '',
          user_id: user.id || 'anonymous',
        })
      }
    } catch (error) {
      // Only log error if it's not a user cancellation
      if (error instanceof Error && error.name !== 'AbortError') {
        console.error('Error sharing:', error)
      }
    }
  }

  const handleGetQrCode = () => {
    setIsQrModalOpen(true)
  }

  const auto_join_team = query.data?.auto_join_team
  let qs = ''
  if (auto_join_team) {
    qs = `?team=${auto_join_team}`
  }

  return (
    <View style={{ marginTop: 3, marginLeft: 5 }}>
      <QrModal
        value={`https://purposity.com/organization/${props.aliasOrValias}${qs}`}
        isOpen={isQrModalOpen}
        setIsOpen={setIsQrModalOpen}
      />

      <Popover.Root>
        <Popover.Trigger asChild>
          <Popover.IconButton aria-label="Share organization">
            <View style={styles.buttonContainer}>
              <View style={styles.circleContainer}>
                <FontAwesomeIcon
                  icon={findIconDefinition({
                    prefix: 'fal',
                    iconName: 'paper-plane',
                  })}
                  color={Colors.black}
                  size={14}
                />
              </View>
            </View>
          </Popover.IconButton>
        </Popover.Trigger>

        <Popover.Portal>
          <Popover.Content align="end" alignOffset={0}>
            <Popover.MenuItem onClick={handleShare}>
              Share Link
            </Popover.MenuItem>
            <Popover.MenuItem onClick={handleGetQrCode}>
              Get QR Code
            </Popover.MenuItem>
            <Popover.Arrow />
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    </View>
  )
}

const styles = StyleSheet.create({
  buttonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  circleContainer: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: Colors.white,
    borderWidth: 2,
    borderColor: Colors.primary,
    justifyContent: 'center',
    alignItems: 'center',
  },
})
